import React from 'react';
import ReactDOM from 'react-dom';
import { ConversationMetadata } from 'models/twilio';
import { calculateUnread } from 'models/twilio/utils';
import UnreadIndicator from '../components/UnreadIndicator';

const renderUnreadIndicator = (
  unreadMessage: HTMLElement,
  metadata: ConversationMetadata,
) => {
  const unreadDiv = document.createElement('div');
  unreadDiv.setAttribute('id', 'unread-indicator');

  unreadDiv.style.width = '100%';
  const isFirstInBlock = unreadMessage.parentNode.firstChild.isEqualNode(unreadMessage);
  const renderSenderEnabled = unreadMessage.parentNode.previousSibling;

  if (isFirstInBlock && renderSenderEnabled) { // Special Handling
    // Get Parent Element: SenderWrapper - Message Wrapper
    const messageWrapper = unreadMessage.parentNode.parentNode;
    messageWrapper.insertBefore(unreadDiv, messageWrapper.firstChild);
  } else {
    unreadMessage.parentElement.insertBefore(unreadDiv, unreadMessage);
  }

  ReactDOM.render(
    <UnreadIndicator unreadCount={calculateUnread(metadata)} />,
    document.getElementById('unread-indicator'),
  );
};

export const removeUnreadIndicator = () => {
  const unreadIndicator = document.getElementById('unread-indicator');
  if (unreadIndicator) {
    unreadIndicator.parentNode.removeChild(unreadIndicator);
  }
};

export default renderUnreadIndicator;
